import { useState, useCallback } from 'react';
import { Props } from './types';

const useAskModal = ({ onYes, onNo, onClose }: Props) => {
  const [modalIsOpen, setModal] = useState<boolean>(false);

  const openModal = useCallback(() => {
    setModal(true);
  }, [setModal]);

  const closeModal = useCallback(() => {
    setModal(false);
  }, [setModal]);

  const handleClose = useCallback(() => {
    closeModal();
    onClose();
  }, [closeModal, onClose]);

  const handleYes = useCallback(() => {
    closeModal();
    onYes();
  }, [closeModal, onYes]);

  const handleNo = useCallback(() => {
    closeModal();
    onNo();
  }, [closeModal, onNo]);

  return {
    modalIsOpen,
    openModal,
    handleClose,
    handleYes,
    handleNo,
  };
};

export default useAskModal;

// TODO: TFR-47 move hooks and effects into proper repository (hooks or utils)
